import { createSelector } from '@opengov/compose-app/reselect';

import { reportTargetSelector } from '../state';

export const selectReportTargetCondition = createSelector(reportTargetSelector, (state) => state.condition);

export const selectSecondReportTargetCondition = createSelector(reportTargetSelector, (state) => state.secondCondition);

export const selectReportTargetElseStatus = createSelector(reportTargetSelector, (state) => state.elseStatus);
